import React from "react";
import { styled } from "@mui/system";
import {
  DISPLAY_FLEX,
  FLEX_DIRECTION_ROW,
  FLEX_DIRECTION_COLUMN,
  FLEX_ALIGN_CENTER,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  BORDER_PRIMARY,
  DISPLAY_BLOCK,
  FLEX_JUSTIFY_START,
  FONT_SIZE_MD,
  FONT_WEIGHT_BOLD,
  TEXT_ALIGN_LEFT,
  MAX_WIDTH,
  FLEX_ALIGN_START,
  OVERFLOW_HIDDEN,
} from "../../config/styles";
import { colors } from "../../config/colors";
import { BORDER_SECONDARY } from "../../config/styles";

import { Modal } from "react-bootstrap";

export const ReportsStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  padding: "0 40px",
  marginLeft: "256px",
  backgroundColor: theme.palette.secondary.contrastText,
  borderRadius: "12px 0px",
  "& .nav-tabs": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_START,
    borderBottom: "none",
    listStyleType: "none",
    padding: "0px",
    gap: "1rem",
  },
  "& .nav-link": {
    display: DISPLAY_BLOCK,
    padding: "12px 16px",
    fontSize: FONT_SIZE_MD,
    fontWeight: FONT_WEIGHT_BOLD,
    textDecoration: "none",
    backgroundColor: colors.background,
    color: colors.nonActive,
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: theme.palette.background.active,
      color: colors.primary,
    },
  },
  "& .tab-content": {
    marginTop: "24px",
    border: BORDER_SECONDARY,
    borderRadius: "8px",
    backgroundColor: theme.palette.secondary.contrastText,
  },
  "& .tab-panel": {
    display: DISPLAY_BLOCK,
  },
  "& .tab-button": {
    width: "68px",
    height: "46px",
    ...theme.typography.body1,
    textAlign: TEXT_ALIGN_LEFT,
    backgroundColor: theme.palette.secondary.contrastText,
    color: colors.custom,
    borderColor: colors.grayBackground,
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "8px",
    cursor: "pointer",
    "&:disabled": {
      backgroundColor: colors.background,
      color: colors.nonActive,
      borderColor: colors.grayBackground,
      cursor: "not-allowed",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: colors.secondary.contrastText,
    },
  },
  "& .MuiButtonBase-root": {
    textTransform: "none",
    margin: "0 24px",
  },
  "& .MuiTabs-root": {
    borderBottom: BORDER_SECONDARY,
    width: MAX_WIDTH,
    textAlign: TEXT_ALIGN_LEFT,
  },
  "& .MuiTypography-body1": {
    width: MAX_WIDTH,
  },
  "& .card-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    flex: "1 1 calc(33.333% - 20px)",
    maxWidth: 'calc(33.333% - 20px)',
    gap: 1,
    padding: "16px",
    borderRadius: "8px",
    border: BORDER_SECONDARY,
    textAlign: TEXT_ALIGN_LEFT,
    gap: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.background.active,
      color: colors.primary,
    },
  },
  "& .custom-report-header ": {
    margin: "16px 0px 24px 0px",
    minHeight: "300px",
    "&::WebkitScrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(134, 140, 161, 0.1)",
      opacity: "10%",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgb(44, 30, 117, 0.2)",
      opacity: "20%",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
      width: "8px !important",
    },
  },
  "& .view-report-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_START,
    borderBottom: BORDER_SECONDARY,
    padding: "16px",
  },
  "& .generate-button": {
    display: DISPLAY_FLEX,
    height: "40px",
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    background: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    margin: "0 auto",
    fontWeight: FONT_WEIGHT_BOLD,
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    "&:disabled": {
      background: theme.palette.primary.main,
      opacity: 0.5,
      cursor: "not-allowed",
      border: "none",
    },
  },
  "& .cancel-button": {
    display: DISPLAY_FLEX,
    height: "40px",
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    background: theme.palette.secondary.contrastText,
    border: BORDER_PRIMARY,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    margin: "0 auto",
    fontWeight: FONT_WEIGHT_BOLD,
    borderRadius: "4px",
    color: colors.custom,
    "&:hover": {
      backgroundColor: colors.background,
      color: colors.custom,
      border: BORDER_PRIMARY,
    },
    "&:disabled": {
      background: colors.background,
      opacity: 0.5,
      cursor: "not-allowed",
      border: "none",
    },
  },
  "& .column-chips": {
    margin: "8px",
    height: "32px",
  },
  "& .disabled-form-input": {
    width: MAX_WIDTH,
    "&:disabled": {
      backgroundColor: colors.background,
      color: colors.nonActive,
      borderColor: colors.grayBackground,
      cursor: "not-allowed",
    },
  },
  "& .custom-card-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    flex: "1 1 calc(50% - 20px)",
    maxWidth: 'calc(50% - 20px)',
    gap: 1,
    padding: "16px",
    borderRadius: "8px",
    border: BORDER_SECONDARY,
    textAlign: TEXT_ALIGN_LEFT,
    cursor: "pointer",
    overflow: OVERFLOW_HIDDEN,
    gap: "4px",
    "&:hover": {
      backgroundColor: theme.palette.background.active,
      color: colors.primary,
    },
  },
}));

export const ModalSyled = styled(Modal)(({ theme }) => ({
  width: MAX_WIDTH,
  "& .modal-content": {
    padding: "1rem !important",
    width: "436px !important",
    margin: "0 auto !important",
  },
  "& .generate-button": {
    display: DISPLAY_FLEX,
    height: "40px",
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    background: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    margin: "0 auto",
    fontWeight: FONT_WEIGHT_BOLD,
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    "&:disabled": {
      background: theme.palette.primary.main,
      opacity: 0.5,
      cursor: "not-allowed",
      border: "none",
    },
  },
  "& .cancel-button": {
    display: DISPLAY_FLEX,
    height: "40px",
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    background: theme.palette.secondary.contrastText,
    border: BORDER_PRIMARY,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    margin: "0 auto",
    fontWeight: FONT_WEIGHT_BOLD,
    borderRadius: "4px",
    color: colors.custom,
    "&:hover": {
      backgroundColor: colors.background,
      color: colors.custom,
      border: BORDER_PRIMARY,
    },
    "&:disabled": {
      background: colors.background,
      opacity: 0.5,
      cursor: "not-allowed",
      border: "none",
    },
  },
}));
